import React from "react";
import { Route } from "react-router-dom";
import {
  loginLink,
  registerLink,
  forgotPasswordLink,
  verifyOtpLink,
  resetPasswordLink,
} from "../../common/routes";
import ForgotPasswordPage from "./forgotPasswordPage";
import LoginPage from "./loginPage";
import RegisterPage from "./registerPage";
import VerifyOtpPage from "./verifyOtpPage";
import ResetPasswordPage from "./resetPasswordPage";

function AuthRouter() {
  return (
    <Route path="/">
      <Route path={loginLink} element={<LoginPage />} />
      <Route path={registerLink} element={<RegisterPage />} />
      <Route path={forgotPasswordLink} element={<ForgotPasswordPage />} />
      <Route path={verifyOtpLink} element={<VerifyOtpPage />} />
      <Route path={resetPasswordLink} element={<ResetPasswordPage />} />
    </Route>
  );
}

export default AuthRouter;
